import { STORAGE_KEYS } from '../constants'

export function clearAuthStorage() {
  try {
    localStorage.removeItem(STORAGE_KEYS.AUTH_TOKEN)
    return true
  } catch (error) {
    return false
  }
}

export function clearAllStorage() {
  try {
    localStorage.clear()
    return true
  } catch (error) {
    return false
  }
}

export function getStorageInfo() {
  try {
    const authToken = localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN)
    return {
      hasAuthToken: !!authToken,
      tokenLength: authToken ? authToken.length : 0,
      storageSize: JSON.stringify(localStorage).length
    }
  } catch (error) {
    return {
      hasAuthToken: false,
      tokenLength: 0,
      storageSize: 0,
      error: error.message
    }
  }
}
